export function MaybeYoureHere() {
  return (
    <section
      data-testid="maybe-youre-here-section"
      className="relative overflow-hidden"
      style={{
        background: "linear-gradient(180deg, #FAFAF8 0%, #F8F7F5 50%, #FAFAF8 100%)",
      }}
    >
      <div
        aria-hidden
        className="absolute top-0 left-0 w-[500px] h-[500px] opacity-[0.03]"
        style={{ background: "radial-gradient(circle, #159E9A 0%, transparent 70%)" }}
      />
      {/* Emotional heart of the page - editorial blocks with generous whitespace */}
      <div className="max-w-7xl mx-auto px-6 md:px-10 pt-[52px] md:pt-16 pb-[42px] md:pb-[60px] relative z-[1]">
        <div className="max-w-[922px] mx-auto">
          <h2 className="font-display text-[41px] sm:text-[55px] lg:text-[69px] leading-[1.08] tracking-tight text-[#1C1917] mb-[45px] md:mb-14 reveal text-center">
            Maybe You&rsquo;re Here Because...
          </h2>
          
          {/* Block 1 */}
          <div className="mb-12 md:mb-[54px] reveal text-center">
            <p className="text-xl md:text-2xl text-[#57534E] leading-relaxed">
              Maybe you&rsquo;ve built a life that looks successful...
            </p>
            <p className="text-xl md:text-2xl text-[#57534E] leading-relaxed mt-2">
              ...but doesn&rsquo;t quite feel like yours anymore.
            </p>
          </div>

          {/* Block 2 */}
          <div className="mb-12 md:mb-[54px] reveal text-center">
            <p className="text-xl md:text-2xl text-[#57534E] leading-relaxed">
              Maybe you know exactly what you want...
            </p>
            <p className="text-xl md:text-2xl text-[#57534E] leading-relaxed mt-2">
              but can&rsquo;t seem to stay with it long enough to build it.
            </p>
          </div>

          {/* Block 3 */}
          <div className="mb-12 md:mb-[54px] reveal text-center">
            <p className="text-xl md:text-2xl text-[#57534E] leading-relaxed">
              Maybe you&rsquo;ve spent so long taking care of everyone else...
            </p>
            <p className="text-xl md:text-2xl text-[#57534E] leading-relaxed mt-2">
              you&rsquo;ve forgotten how to hear yourself.
            </p>
          </div>

          {/* Block 4 */}
          <div className="mb-12 md:mb-[54px] reveal text-center">
            <p className="text-xl md:text-2xl text-[#57534E] leading-relaxed">
              Or maybe you&rsquo;re simply ready...
            </p>
            <p className="text-xl md:text-2xl text-[#57534E] leading-relaxed mt-2">
              for a life that fits better than &ldquo;fine.&rdquo;
            </p>
          </div>

          {/* Bridge statement */}
          <div className="mt-10 md:mt-14 reveal text-center">
            <div className="w-[60%] mx-auto h-px bg-[#E8E6E3] mb-8" />
            <p className="font-display text-[32px] md:text-[38px] text-[#1C1917] leading-[1.45]">
              You don&rsquo;t need a different life.
            </p>
            <p className="font-display text-[32px] md:text-[38px] text-[#1C1917] leading-[1.45] mt-2">
              You need a truer starting place.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
